import axios from "axios"

const fetchReviewNameFromButtonName = (buttonName: string, label: string) => {
    return buttonName.replace(`${label}_`, "")
}
const clickEventForReplyButton = () => {
    const gbpReviewsIndex = document.getElementById('gbp_reviews_index') as HTMLElement;
    gbpReviewsIndex.querySelectorAll('.reply input[type="submit"][name^="reply_button"]').forEach((replyButton) => {
        replyButton.addEventListener('click', () => {
            if (confirm('返信しますか？')) {
                const buttonName = replyButton.getAttribute('name') as string
                const reviewName = fetchReviewNameFromButtonName(buttonName, 'reply_button')
                const replyBodyId = document.getElementById(`reply_body_${reviewName}`) as HTMLTextAreaElement;
                submitReviewReplyRequest(reviewName, replyBodyId.value)
            }
        });
    });
}
const clickEventForReplyDeleteButton = () => {
    const gbpReviewsIndex = document.getElementById('gbp_reviews_index') as HTMLElement;
    gbpReviewsIndex.querySelectorAll('.reply input[type="submit"][name^="reply_delete_button"]').forEach((replyDeleteButton) => {
        replyDeleteButton.addEventListener('click', () => {
            if (confirm('返信を削除しますか？')) {
                const buttonName = replyDeleteButton.getAttribute('name') as string
                const reviewName = fetchReviewNameFromButtonName(buttonName, 'reply_delete_button')
                submitDeleteReviewReplyRequest(reviewName)
            }
        });
    });

}

const submitReviewReplyRequest = (reviewName: string, replyBody: string) => {
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    const url = `/staff/api/gbp/reviews/${encodeURIComponent(reviewName)}/reply`
    const config = {headers: {'X-CSRF-Token': token}}
    const params = {reply_body: replyBody}
    axios.put(url, params, config)
        .then(response => {
            const data = response.data;
            if (data['result']) {
                controlReplyDeleteButton(reviewName, false)
                alert('返信しました。')
            } else {
                alert(data['message'])
            }
        }).catch(error => {
            alert('エラーが発生しました。')
    });
}

const submitDeleteReviewReplyRequest = (reviewName: string) => {
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    const url = `/staff/api/gbp/reviews/${encodeURIComponent(reviewName)}/reply`
    const config = {headers: {'X-CSRF-Token': token}}
    axios.delete(url, config)
        .then(response => {
            const data = response.data;
            if (data['result']) {
                const replyBodyId = document.getElementById(`reply_body_${reviewName}`) as HTMLTextAreaElement;
                replyBodyId.value = ''
                controlReplyDeleteButton(reviewName, true)
                alert('削除しました。')
            } else {
                alert(data['message'])
            }
        }).catch(error => {
        alert('エラーが発生しました。')
    });
}

const controlReplyDeleteButton = (reviewName: string, disabled: boolean) => {
    const selectorReplyButton = `.reply input[type="submit"][name="reply_delete_button_${reviewName}"`
    const deleteReplyButton = document.querySelector(selectorReplyButton) as HTMLInputElement;
    deleteReplyButton.disabled = disabled;
}


document.addEventListener('DOMContentLoaded', () => {

    const gbpReviewsIndex = document.getElementById('gbp_reviews_index') as HTMLElement;
    if (gbpReviewsIndex == null) {
        return;
    }

    clickEventForReplyButton()
    clickEventForReplyDeleteButton()
});
